import { render } from "./ProfileLoginId.vue?vue&type=template&id=3dc6d6b9"
import script from "./ProfileLoginId.vue?vue&type=script&lang=js"
export * from "./ProfileLoginId.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__